import List from "@/components/list";
import vue from "@/main";
import router from "@/router";

const Table = (args) => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const { groupSourceType = 1, isOnline = 1, isParty = 0, isSamllClass = 0 } = props

  function arraySpanMethod({ row, column, rowIndex, columnIndex }) {  }

  // 删除班委人员
  function deleteGroup(enroll) {
    vue.$emit("deleteGroup", enroll);
  }
  // 编辑班内职务
  function updateGroup(enroll) {
    router.push({
      path: "/offlineClass/editClassGroup",
      query: { classId: args.props.classId, id: enroll.uuid, isOnline, isSamllClass },
    });
  }

  //查看详情
  function goDetail(enroll) {
    router.push({
      path: "/offlineClass/editClassGroup",
      query: { classId: args.props.classId, id: enroll.uuid, onlyLook: true, isSamllClass },
    });
  }

  const Deal = ({ props: { vo } }) => {
    const enroll = vo.row;
    const dealConf = [
      ["icon-edit", "编辑", () => updateGroup(enroll), "group:update"],
      ["icon-delete-group", "解散", () => deleteGroup(enroll), "group:delete"],
    ];
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const ClassName = ({ props: { vo } }) => {
    const offlineClass = vo.row;
    return (
      <div class="base-hover-char" onClick={() => goDetail(offlineClass)}>
        {offlineClass.groupName}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "班组名称",
      prop: "groupName",
      minWidth: "150",
      showOverflowTooltip: true,
      render: (vo) => <ClassName vo={vo} />,
    },
    {
      label: "组长",
      prop: "leaderUserName",
      minWidth: "150",
      showOverflowTooltip: true,
    },
    {
      label: "成员数量",
      prop: "memberCount",
      width: "150",
      showOverflowTooltip: true,
    },

  ];

  if (isSamllClass == 1) {
    AccountTableConfig.unshift(
      {
        label: "所属小班",
        prop: "smallClassName",
        minWidth: "150",
        showOverflowTooltip: true,
      }
    )

  }

  if (groupSourceType === 1) {
    AccountTableConfig.unshift(
      {
        type: "selection",
        label: "main"
      }
    )

    AccountTableConfig.push(
      {
        label: "操作",
        fixed: "right",
        width: "80",
        render: (vo) => <Deal vo={vo} />,
      }
    )
  }
  return (
    <List
      {...args}
      empty-text={(isParty === 0 || groupSourceType == 1) ? "尚未添加任何班组，点击左上角【添加】可进行班组添加" : "分组信息由党校同步，无法自行添加"}
      onSelectionChange={RCSelectionChange}
      span-method={arraySpanMethod}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
